import { getSportOptions } from './get-sport-options';
import { getDynamicMatchOptions } from './get-dynamic-match-options';

export const getDynamicOptions = (
  fieldKey: string,
  formData: any,
  creativityType?: string,
  baseOptions?: any
): any[] | undefined => {
  // 1. Prioridad: Partidos preconfigrados (más específico)
  const matchOptions = getDynamicMatchOptions(fieldKey, formData, creativityType);
  if (matchOptions) return matchOptions;

  // 2. Fallback: Opciones genéricas por sport
  const sportOptions = getSportOptions(fieldKey, formData, baseOptions);
  if (sportOptions) return sportOptions;

  // 3. Fallback final
  return baseOptions;
};
